const SidebarTypes = {
    TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR'
}

export default SidebarTypes;